import { Component } from '@angular/core';

@Component({
  selector: 'app-user-location',
  standalone: true,
  imports: [],
  templateUrl: './user-location.component.html',
  styleUrl: './user-location.component.css'
})
export class UserLocationComponent {

}
